import { render, staticRenderFns } from "./CalificacionGrupo.vue?vue&type=template&id=284066ac&scoped=true"
import script from "./CalificacionGrupo.vue?vue&type=script&lang=js"
export * from "./CalificacionGrupo.vue?vue&type=script&lang=js"
import style0 from "./CalificacionGrupo.vue?vue&type=style&index=0&id=284066ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284066ac",
  null
  
)

export default component.exports